/*********************** Custom JS for Boost AI Search & Discovery ************************/

// <div class="price-ui-badges price-ui-badges--square">
//       <div class="price-ui-badge" data-price-ui-badge="" data-display-percent="true">
//       <div class="price-ui-badge__sticker">
//       <span class="price-ui-badge__sticker-text" data-badge=""> -30%</span>
//       </div>
//     </div>
//   </div>

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductPrice', {
      name: 'Customize price using first available variant #228704',
      apply: () => ({
        props: (props, element) => {
          try {
            const productData = element?.getParentElm()?.getParams()?.props?.data;
            let productItem = document.querySelector('.boost-sd__product-item[id="' + productData.id + '"]');
            const productPriceProps = props?.data;
            console.log("productPriceProps ", productPriceProps)
            if (productData?.variants?.length > 0 && productPriceProps) {
              const boostFirstVariant = productData.variants.find(variant => variant.available) || productData.variants[0];
              const variantPrice = parseFloat(boostFirstVariant.price);
              const compareAtPrice = boostFirstVariant.compare_at_price ? parseFloat(boostFirstVariant.compare_at_price) : null;
              productPriceProps.price_min = variantPrice;
              productPriceProps.compare_at_price_min = compareAtPrice;

              if (compareAtPrice !== null && compareAtPrice > variantPrice) {
                const saleAmount = compareAtPrice - variantPrice;
                const salePercent = Math.round((saleAmount * 100) / compareAtPrice);
                productPriceProps.saleAmount = saleAmount;
                productPriceProps.salePercent = salePercent + "%";
                // productPriceProps.onSale = true;
                productPriceProps.isSale = true;
                /* Start-Boost-235741 */
                productPriceProps.price_min = variantPrice;
                productPriceProps.compare_at_price_min = compareAtPrice;
                /* End-Boost-235741 */
                
              } else {
                productPriceProps.onSale = false;
              }

               if(productPriceProps.isSale == true){
                  productItem.querySelector('.boost-sd__product-image-column--right').innerHTML = `<div class="boost-sd__product-label boost-sd__product-label--rectangle boost-sd__product-label--sale" style="color: rgb(255, 255, 255); background-color: rgb(239, 51, 64);"><span class="boost-sd__product-label-text"><span>${productPriceProps.salePercent}</span></span></div>`
                }
            }
          } catch (error) {
            console.warn("Error in ProductPrice Plugin:", error);
          } finally {
            return props;
          }
        },
      }),
    });
  }
]);

// Start Boost 217098
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('FormatCurrency', {
            name: 'Show Trailing Zeros',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        // Start customization--------------------------------------------
                        // const formatMoneyHelper = element.getHelpers().formatMoney;
                        const value = element.getParams().props.value; // Get price
                        const customValue = formatMoney(Number(value), window.boostSDAppConfig?.shop?.money_format, true);

                      if (element && element.getRootElm()) {
                        element.getRootElm().querySelector('.boost-sd__format-currency span').innerHTML = customValue;
                      }
                        // End-------------------------------------------------------------
                    } catch (e) {
                        console.error(e);
                    }
                },
            }),
        });
    }
]);

// End Boost 217098
const updateProductItem2 = (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
        name: 'product card',
        enabled: true,
        apply: () => ({
            afterRender(element) {
                try {
                    let productData =
                        element.getParams()?.props?.product ||
                        element.getParams()?.props?.productData ||
                        element.getParams()?.props?.data;
                    let productItems = document.querySelectorAll('.boost-sd__product-item[id="' + productData.id + '"]');

                    Array.from(productItems).forEach(productItem => {
                        if (productData.product_type == 'Distillati' || productData.product_type == 'Liquori' || productData.product_type == 'Dolci' || productData.product_type == 'Idee Regalo') {
                            if (productItem.querySelector('.boost-sd__format-currency--price-compare')) {
                                productItem.querySelector('.boost-sd__format-currency--price-compare').style.display = 'none';
                            }
                            if (productItem.querySelector('.boost-sd__product-label.boost-sd__product-label--sale .boost-sd__product-label-text')) {
                                productItem.querySelector('.boost-sd__product-label.boost-sd__product-label--sale .boost-sd__product-label-text').innerHTML = '<span>HIT</span>';
                            }
                        }
                    })

                    if (!productItem) return;
                } catch (e) {}
            },
        }),
    });

    componentRegistry.useComponentPlugin('SearchProductItem', {
        name: 'product card',
        enabled: true,
        apply: () => ({
            afterRender(element) {
                try {
                    let productData =
                        element.getParams()?.props?.product ||
                        element.getParams()?.props?.productData ||
                        element.getParams()?.props?.data;
                    let productItems = document.querySelectorAll('.boost-sd__suggestion-queries-item[data-id="' + productData.id + '"]');

                    Array.from(productItems).forEach(productItem => {
                        if (productData.product_type == 'Distillati' || productData.product_type == 'Liquori' || productData.product_type == 'Dolci' || productData.product_type == 'Idee Regalo') {
                            if (productItem.querySelector('.boost-sd__format-currency--price-compare')) {
                                productItem.querySelector('.boost-sd__format-currency--price-compare').style.display = 'none';
                            }
                            // Remove sold-out badge
                            if (productItem.querySelector('.boost-sd__suggestion-queries-item-badge.boost-sd__suggestion-queries-item-badge--sold-out')) {
                                productItem.querySelector('.boost-sd__suggestion-queries-item-badge.boost-sd__suggestion-queries-item-badge--sold-out').remove();
                            }
                            if (productItem.querySelector('.boost-sd__suggestion-queries-item-badge.boost-sd__suggestion-queries-item-badge--sale span')) {
                                productItem.querySelector('.boost-sd__suggestion-queries-item-badge.boost-sd__suggestion-queries-item-badge--sale span').innerHTML = '<span>HIT</span>';
                            } else {
                                if (productItem.querySelector('.boost-sd__suggestion-queries-item-product--left')) {
                                  // productItem.querySelector('.boost-sd__suggestion-queries-item-product--left').insertAdjacentHTML('afterbegin', '<div class="boost-sd__suggestion-queries-item-badge boost-sd__suggestion-queries-item-badge--sale"><span><span>HIT</span></span></div>');
                                }
                            }
                        }
                    })

                    if (!productItem) return;
                } catch (e) {}
            },
        }),
    });

    componentRegistry.useComponentPlugin('ProductList', {
        name: 'Modify Product List',
        enabled: true,
        apply: () => ({
            afterRender(element) {
                try {
                    let currentUrl = window.location.href.split('?')[0] + '?view=desc';
                    $.ajax({
                        method: 'GET',
                        url: currentUrl,
                        dataType: 'json',
                        success: function(result) {
                            if (result.collection.hasOwnProperty('description') && result.collection.description != '') {
                                let descHtml = `
                                                  <div class="container decription__wrapper">
                                                    <div class="one-whole column">
                                                      <div class="collection_description boost-pfs-filter-collection-description">
                                                        ${result.collection.description}
                                                      </div>
                                                    </div>
                                                  </div>
                                                `;
                                let boostSdRight = document.querySelector('.boost-sd-right');
                                if (boostSdRight && !boostSdRight.querySelector('.decription__wrapper')) {
                                    boostSdRight.insertAdjacentHTML('afterbegin', descHtml);
                                }
                            }
                        },
                    });
                } catch (error) {
                    console.log(error);
                }
            },
        }),
    });
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([updateProductItem2]);


function formRequest(value) {
    return new Promise((resolve, reject) => {
        var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
        xhr.open('GET', value);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => resolve(xhr);
        xhr.onerror = () => reject(xhr.statusText);
        xhr.send();
    });
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('FilterOption', {
            name: 'ProductList - call get Products Data',
            apply() {
                let hasUpdated = false;
                return {
                    afterRender(element) {
                        try {
                            const rootElm = element.getRootElm();
                            const props = element.getParams().props;
                          if(props.option.filterOptionId == "pf_c_collection"){
                             console.log(rootElm); 
                             var filterOption = rootElm.querySelectorAll('.boost-sd__filter-option-item-multilevel-collections');
                               filterOption.forEach(function(item) {
                                    item.addEventListener('click', function() {
                                      setTimeout(function() {
                                        window.location.reload();
                                      },100)
                                    });
                                  });
                             }
                        } catch (error) {
                            console.warn(error)
                        }
                    },
                };
            },
        });
    }
]);


/*********************** Custom JS for AJAX Cart  ************************/
if (window.boostSDAppConfig) {
    window.boostSDAppConfig.themeSettings.cart.enableCart = true;
    window.boostSDAppConfig.themeSettings.cart.cartStyle = 'none';
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useModulePlugin('CartAPI', {
            name: 'Custom onSucces add to cart',
            apply(builder) {
                builder.on('methodFulfilled', 'addToCart', async (payload) => {
                    // Update theme cart
                    updateCart();
                    return payload;
                });
            },
        });
    },
]);

function updateCart() {
    $.ajax({
        url: '/cart.js',
        dataType: 'json',
        cache: false,
        success(cart) {
            setTimeout(function() {
                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                    $.fancybox.close();
                }
                if ($('#header').is(':visible')) {
                    $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                    $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                    $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                    const $cartContainer = $(this).parent();
                    if ($cartContainer.hasClass('active_link')) {
                        $('body').addClass('blocked-scroll');
                    } else {
                        $('body').addClass('blocked-scroll');
                    }

                    // Scroll to the top of the page unless the header is fixed
                    const header = document.getElementById('header');
                    if (header.classList.contains('mobile_nav-fixed--false')) {
                        window.scroll({
                            top: 0,
                            left: 0,
                            behavior: 'smooth',
                        });
                    }
                }
            }, 5);
        },
    });
}

function refreshCart(cart) {
    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    const value = $cartBtn.text() || '0';
    let cartItemsHTML = '';
    let cartDiscountsHTML = '';
    let cartActionHTML = '';
    let cartSavingsHTML = '';
    const $cartForm = $('[data-cart-form]');
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;
    $cartForm.data('total-discount', cart.total_discount);
    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
    if (cart.item_count === 0) {
        $('.js-empty-cart__message').removeClass('hidden');
        $cartForm.addClass('hidden');
    } else {
        $('.js-empty-cart__message').addClass('hidden');
        $cartForm.removeClass('hidden');
        let totalSaving = 0; // adding counter variables for total cart savings
        let saving = 0;
        $.each(cart.items, (index, item) => {
            const itemDiscounts = item.discounts;
            let discountMessage = '';
            for (let i = 0; i < itemDiscounts.length; i++) {
                const {
                    title
                } = itemDiscounts[i];
                discountMessage = `<p class="notification-discount meta">${title}</p>` ;
            }
            const lineID = index + 1 ;
            cartItemsHTML +=
                `<li class="mini-cart__item" data-cart-item="" data-line-id="${lineID}" data-variant-id="${item.id}">` +
                `<a href="${item.url}">`;
            if (item.image) {
                cartItemsHTML +=
                    `${'<div class="cart_image">' + '<img src="'}${item.image
            .replace(/(\.[^.]*)$/, '_compact$1')
            .replace('http:', '')}" alt="${htmlEncode(item.title)}" data-wg-notranslate="">` + '</div></a>' ;
            }
            cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;
            if (item.selling_plan_allocation) {
                cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            if (item.properties) {
                cartItemsHTML += '<div class="mini-cart__item-properties">';
                $.each(item.properties, (title, value) => {
                    if (value && value !== 'on') {
                        cartItemsHTML += `<div class="mini-cart__item-property">${title}: ${value}</div>` ;
                    }
                }) ;
                cartItemsHTML += '</div>' ;
            }
            cartItemsHTML += ' '.</div><div class="mini-cart__item-price">';
            $.ajax({
                dataType: 'json',
                async: false,
                cache: false,
                url: `/products/${item.handle}.js`,
                success(data) {
                    let productData = data;
                    // If item has more than one variant, need to make sure we are pulling data from the correct variant
                    if (productData.variants) {
                        const itemVariants = productData.variants;
                        if (itemVariants.length > 1) {
                            for (let v = 0; v < itemVariants.length; v++) {
                                if (itemVariants[v].id === item.id) {
                                    productData = itemVariants[v];
                                }
                            }
                        }
                    }

                    // If compare at price exists then item is on sale
                    if (productData.compare_at_price && productData.compare_at_price > productData.price) {
                        productHasSale = true;
                        productCompareAtPrice = productData.compare_at_price;
                        productFinalPrice = productData.price;
                    } else {
                        // Check required for non-sale items
                        productHasSale = false;
                    }
                },
            });
            if (productHasSale === true) {
                // puts the slash through the old item price
                const itemPrice = `${window.Shopify.formatMoney(
          productFinalPrice,
          $('body').data('money-format'),
        )} <span class="money was_price">${window.Shopify.formatMoney(
          productCompareAtPrice,
          $('body').data('money-format'),
        )}</span>`;
                cartItemsHTML += `<span class="money sale">${itemPrice}`;

                // Total savings
                saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
                totalSaving = saving + totalSaving;
            } else if (item.price > item.final_price) {
                // puts the slash through the old item price
                const itemPrice = `${window.Shopify.formatMoney(
          item.final_price,
          $('body').data('money-format'),
        )} </span><span class="money was_price">${window.Shopify.formatMoney(
          item.price,
          $('body').data('money-format'),
        )}</span>`;
                cartItemsHTML += `<span class="money sale">${itemPrice}`;
            } else {
                const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
                if (item.price > 0) {
                    cartItemsHTML += `<span class="money">${itemPrice}</span>`;
                } else {
                    cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span>`;
                }
            }
            cartItemsHTML += '</span></div>';

            // Unit price

            if (item.unit_price_measurement && item.price > 0) {
                let unitPriceMeasurementReferenceValue = '';
                if (item.unit_price_measurement.reference_value !== 1) {
                    unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
                }
                cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${
          item.unit_price_measurement.quantity_unit
        | ${Shopify.formatMoney(
          item.unit_price,
          $('body').data('money-format'),
        )} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
            }
            if (item.price > item.final_price) {
                cartItemsHTML += discountMessage;
            }
            cartItemsHTML += '<div class="product-quantity-box">' ;
            cartItemsHTML +=
                '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' ;
            cartItemsHTML += `.<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart">` ;
            cartItemsHTML +=
                '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' ;
            cartItemsHTML += ' '.</div></div></li>